import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustStrip from "./components/TrustStrip";
import ValueProposition from "./components/ValueProposition";
import SystemsOverview from "./components/SystemsOverview";
import IndustryApplications from "./components/IndustryApplications";
import PositioningStatement from "./components/PositioningStatement";
import CasePreview from "./components/CasePreview";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main style={{ fontFamily: "Inter, sans-serif" }} className="bg-white text-[#1F2933] antialiased">
      <Navbar />
      <Hero />
      <TrustStrip />
      <ValueProposition />
      <SystemsOverview />
      <IndustryApplications />
      <PositioningStatement />
      <CasePreview />
      <CTASection />
      <Footer />
    </main>
  );
}
